import {AsyncPipe, DatePipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';

import {MatButton, MatIconButton} from '@angular/material/button';
import {MatCard, MatCardActions, MatCardContent, MatCardHeader, MatCardTitle,} from '@angular/material/card';
import {MatDialog} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListItem, MatListItemLine, MatListItemTitle} from '@angular/material/list';
import {MatSelectModule} from '@angular/material/select';

import {AccessTokenDialogComponent} from '@app/admin/access-token-dialog/access-token-dialog.component';
import {Client, ClientService} from '@app/admin/client.service';
import {User, UserService} from '@app/shared/user.service';
import {Observable} from 'rxjs';

@Component({
    selector: 'frog-access-token-card',
    imports: [
        AsyncPipe,
        MatButton,
        MatCard,
        MatCardContent,
        MatCardHeader,
        MatCardTitle,
        MatCardActions,
        MatIcon,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatListItem,
        MatListItemTitle,
        MatListItemLine,
        DatePipe,
        MatIconButton,
    ],
    templateUrl: './access-token-card.component.html',
    styleUrl: './access-token-card.component.scss',
})
export class AccessTokenCardComponent implements OnInit {
    public users$: Observable<User[]>;
    public client$: Observable<Client>;
    public accessTokens$: Observable<any>;

    constructor(
        private userService: UserService,
        private clientService: ClientService,
        private matDialog: MatDialog,
    ) {}

    ngOnInit(): void {
        this.users$ = this.userService.users;
        this.client$ = this.clientService.client;
        this.accessTokens$ = this.clientService.listAccessTokens();
    }

    openDialog() {
        this.matDialog
            .open(AccessTokenDialogComponent, {
                width: '600px',
            })
            .afterClosed()
            .subscribe(() => {
                this.accessTokens$ = this.clientService.listAccessTokens();
            });
    }

    removeAccessToken(accessTokenId: string) {
        this.clientService.removeAccessToken(accessTokenId).subscribe((result) => {
            this.accessTokens$ = this.clientService.listAccessTokens();
        });
    }
}
